export default function hauntSeoWidget() {
  const widgetName = 'hauntSeoWidget';
  const widgetOpts = hauntSeoWidgetOpts;
  const $widget = $(`#${widgetName}`);

  return saffire.widgets.cardWidget($($widget), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    showDescription: true,
    hasImages: false,
    lazyLoadImages: false,
    imageIsBackground: false,
    textOverImage: false,
    itemsPerPanel: 1,
    maxItemsVisible: 1,

    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData) {
        createCustomSeo(data.items);
        moveWidgetToMainContent(widgetName);
      } else {
        $widget.remove();
      }
    },
  });

  function createCustomSeo(widgetData) {
    const $seo = $widget.find('.card-widget-item');
    const { Title, Description, DetailLinkText, URL } = widgetData[0];
    const localUrl = isLocalUrl(URL) ? '' : 'target="_blank"';

    $seo.replaceWith(`
      <h1 class="seo-title">${Title}</h1>
      <div class="seo-description">${Description}</div>
      <div class="seo-cta-section">
        <div class="seo-detailLinkText">${DetailLinkText}</div>
        ${URL == null ? '' : `<a href="${URL}" class="button" ${localUrl}>GET A DEMO TODAY</a>`}
      </div>
    `);
  }
}

function isLocalUrl(urlToCheck) {
  const clientPath = SITEBASEURL;
  return urlToCheck !== null && urlToCheck.includes(clientPath);
}

function moveWidgetToMainContent(widgetName) {
  const $widget = $(`#${widgetName}`);
  const $breadcrumbs = $('#MainContent_content_smp_breadcrumbs');

  if ($breadcrumbs.length) {
    $widget.insertAfter($breadcrumbs);
  } else {
    $('.content').prepend($widget);
  }

  $('#hauntSubpageWidgets').empty();
}